import  React, {useEffect} from 'react';
import style from './LakeChart.module.css';
import ChartModeButton from "../UI/buttons/ChartModeButton";
import DualAxisChart from "./DualAxisChart";
import {LAKE_CHART_MODES} from "../utils/ChartFormatUtils";
import {Container} from "react-bootstrap";
import LegendElement from "./LegendElement";
import WaterLevelSvg from "../assets/svg/WaterLevelSvg";
import WaterTemperatureSvg from "../assets/svg/WaterTemperatureSvg";
import DownloadButton from "../UI/buttons/DownloadButton";
import {useChartData} from "./useChartData";
import {assembleChartData} from "./ChartDataAssembler";
import * as ChartSettings from "./ChartSettings";
import MessageBlock from "../UI/blocks/MessageBlock";

function LakeChart() {

    useEffect(() => {
        ChartSettings.setupDefaults()
    }, [])

    const [activeMode, setActiveMode, activeData, downloadXlsxData] = useChartData()

    function formatLegendValue(value) {
        return value ? value.toFixed(1).toString().replace(".", ",") : null
    }

    function isDataLoaded() {
        return activeData && activeData.temperatures && activeData.waterLevels
    }

    function isDataEmpty() {
        const elementNotNull = element => !!element;
        return !activeData.temperatures.some(elementNotNull)
            && !activeData.waterLevels.some(elementNotNull)
    }

    const DEFAULT_ICON_COLOR = 'white'

    const CHART_MODE_BUTTONS = [
        {mode: LAKE_CHART_MODES.week, buttonValue: 'Tydzień', errorValue: 'Nie udało się pobrać danych za ostatni tydzień'},
        {mode: LAKE_CHART_MODES.month, buttonValue: 'Miesiąc', errorValue: 'Nie udało się pobrać danych za ostatni miesiąc'},
        {mode: LAKE_CHART_MODES.year, buttonValue: 'Rok', errorValue: 'Nie udało się pobrać danych za ostatni rok'},
        {mode: LAKE_CHART_MODES.max, buttonValue: 'Max', errorValue: 'Nie udało się pobrać danych za cały okres'}
    ]

    return (
        <div className={style.wrapper}>
            <div className={style.backgroundWave}></div>

            <div className={style.main}>
                <Container className={style.container}>

                    <div className={style.switchModeButtons}>
                        { CHART_MODE_BUTTONS.map((obj, index) =>
                            <ChartModeButton
                                activeMode={activeMode}
                                setActiveMode={setActiveMode}
                                mode={obj.mode}
                                key={index}
                            >
                                {obj.buttonValue}
                            </ChartModeButton>
                        )}
                    </div>

                    <div className={style.downloadButton}>
                        <DownloadButton onClick={() => downloadXlsxData()}>
                            Pobierz dane
                        </DownloadButton>
                    </div>

                    { isDataLoaded()
                        ? isDataEmpty()
                            ? <MessageBlock>{CHART_MODE_BUTTONS.find(mode => mode.mode === activeMode).errorValue}</MessageBlock>
                            : <>
                                <div className={style.legend}>
                                    <LegendElement
                                        value={formatLegendValue(activeData.waterLevels[activeData.waterLevels.length - 1])}
                                        icon={<WaterLevelSvg
                                            color={DEFAULT_ICON_COLOR}
                                            className={style.icon}
                                        />}
                                        title="POZIOM WODY"
                                        unit="cm"
                                        isReverseIcon={false}
                                    />

                                    <LegendElement
                                        value={formatLegendValue(activeData.temperatures[activeData.temperatures.length - 1])}
                                        icon={<WaterTemperatureSvg
                                            color={DEFAULT_ICON_COLOR}
                                            className={style.icon}
                                        />}
                                        title="TEMPERATURA"
                                        unit="°C"
                                        isReverseIcon={true}
                                    />
                                </div>

                                <DualAxisChart data={assembleChartData(activeData)} className={style.chart}/>
                            </>
                    : <MessageBlock>Ładowanie... </MessageBlock> }
                </Container>
            </div>
        </div>
    )
}

export default LakeChart;